import { getRequest, postRequest } from '../../services/base'

// Every endpoint here is unauthenticated on the server (no 401/403 possible), so
// the shared helpers' sign-out and not-permitted redirects can never fire on them.

// How this host signs in cannot change while a page is loaded, but the layout
// (on every route change), the login page and the OAuth callback all need it -
// and StrictMode runs each of those effects twice in development. One request
// per page load, shared by everyone; a failed one is not kept, so it retries.
let loginConfigRequest = null

export const getLoginConfig = () => {
  if (!loginConfigRequest) {
    loginConfigRequest = getRequest('/login_config/', false).then((res) => {
      if (!res?.status) loginConfigRequest = null
      return res
    })
  }
  return loginConfigRequest
}

export const cognitoSignIn = (email, password) =>
  postRequest('/cognito/login/', { email, password })

export const answerNewPassword = (challengeId, newPassword) =>
  postRequest('/cognito/login/challenge/', {
    challenge_id: challengeId,
    new_password: newPassword,
  })

export const requestPasswordReset = (email) =>
  postRequest('/cognito/forgot_password/', { email })

export const confirmPasswordReset = (email, code, newPassword) =>
  postRequest('/cognito/confirm_forgot_password/', {
    email,
    code,
    new_password: newPassword,
  })

export const getProviderRedirect = (provider) =>
  getRequest(
    `/generate_auth_redirect_url/?identity_provider=${encodeURIComponent(provider)}`,
    false
  )
